import { useRouter } from 'vue-router';

import { useMobileNav } from '@/shared/helpers/mobile-nav';

declare global {
    interface Window {
        zs: {
            navigateTo(path: string): void;
            openSidebar(): void;
            closeSidebar(): void;
            toggleSidebar(): void;
        };
    }
}

export function useZSWindowHelpers() {
    const router = useRouter();
    const mobileNav = useMobileNav();

    window.zs = {
        navigateTo(path: string) {
            router.push(path);
        },
        // Sidebar drawer controls — the native mobile app opens the nav this way
        // (in-app there's no web hamburger; the native chrome triggers it).
        openSidebar() {
            mobileNav.open();
        },
        closeSidebar() {
            mobileNav.close();
        },
        toggleSidebar() {
            mobileNav.toggle();
        }
    };
}
